function moveCurrencyPicker() {
  var $picker = $('#currency-picker');
  var $search = $('.ajax-search');
  var $mobileMenu = $('.header__menu--mobile');
  var $mobileMenuC = $('.header__menu--mobile .container');

    if (!$picker.parent().is($mobileMenu)) {
      $picker.appendTo($mobileMenu);
    }
    if (!$search.parent().is($mobileMenuC)) {
      $search.appendTo($mobileMenuC);
    }
}

$(document).ready(function() {
    if ($(window).width() <= 799) {
        moveCurrencyPicker();
    }
});

$(window).on('resize', function() {
    if ($(window).width() <= 799) {
        moveCurrencyPicker();
    }
});

$(document).ready(function () {

    function updateColourTitle() {
        const $fieldset = $('fieldset.type-colour');
        const selectedValue = $fieldset
            .find('input[type="radio"]:checked')
            .val();

        $fieldset.find('.selected-colour').text(selectedValue);
    }

    updateColourTitle();

    $('fieldset.type-colour input[type="radio"]').on('change', updateColourTitle);

});

$(document).ready(function () {
    const $details = $('.cart-details details');

    $details.removeAttr('open');

    $details.children('summary').on('click', function (e) {
        e.preventDefault();

        const $current = $(this).parent('details');

        $details.not($current).removeClass('is-open');

        $current.toggleClass('is-open');
    });
});

$(document).on('click', '.header-search a', function (e) {
    e.preventDefault();
    $('.ajax-search').toggleClass('active');
    $('.header-search').toggleClass('active');
});

$(document).on('click', '.header-currency', function (e) {
    e.preventDefault();
    $('#currency-picker').slideToggle();
});

function formatPrice(product) {
    if (!product.price) return '';

    var priceMin = product.price_min || product.price;
    var priceMax = product.price_max || product.price;

    priceMin = priceMin * 120;
    priceMax = priceMax * 120;

    var formatter = new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP'
    });

    if (priceMin !== priceMax) {
        return 'From ' + formatter.format(priceMin / 100);
    }

    return formatter.format(priceMin / 100);
}

(function ($) {
    var $search = $('[data-ajax-search]');
    var $input = $search.find('input');
    var $results = $search.find('.ajax-search-results');
    var $list = $results.find('ul');
    var debounceTimer;

    $input.on('input', function () {
        var query = $(this).val();

        clearTimeout(debounceTimer);

        if (query.length < 2) {
            $results.hide();
            return;
        }

        debounceTimer = setTimeout(function () {
            $.getJSON(
                '/search/suggest.json', {
                    q: query,
                    resources: {
                        type: 'product',
                        limit: 5,
                        options: {
                            unavailable_products: 'hide'
                        }
                    }
                }
            ).done(function (data) {
                var products = data.resources.results.products;

                if (!products.length) {
                    $results.hide();
                    return;
                }

                var html = '';

                products.forEach(function (product) {
                    html += `
            <li>
              <a href="${product.url}">
                <img src="${product.image}" alt="${product.title}">
                <span>${product.title}</span>
                <span class="ajax-search-price">
                ${formatPrice(product)}
                </span>
              </a>
            </li>
          `;
                });

                $list.html(html);
                $results.show();
            });
        }, 200);
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('[data-ajax-search]').length) {
            $results.hide();
        }
    });

})(jQuery);

$(function () {
    function initFooterAccordion() {
        if ($(window).width() > 800) {
            $('.footer__menu-items').show();
            $('.footer__menu').removeClass('is-open');
            return;
        }

        $('.footer__menu h3').off('click.footer').on('click.footer', function () {
            var $menu = $(this).closest('.footer__menu');
            var $items = $menu.find('.footer__menu-items');

            $menu.toggleClass('is-open');
            $items.stop(true, true).slideToggle(250);
        });
    }

    initFooterAccordion();
    $(window).on('resize', initFooterAccordion);
});

$(function () {

    $(document).on('click', '.menu-open', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $('.header__menu--mobile').addClass('active');
        $('body').addClass('fixed');
    });

    $(document).on('click', '.header__menu--mobile > svg', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $menu = $('.header__menu--mobile');

        $menu.removeClass('active');
        $('body').removeClass('fixed');

        $menu.find('li').removeClass('active inactive');
        $menu.find('li > ul').slideUp(250);
    });

});

$(document).on('click', '.header__menu--mobile li > a', function (e) {

    var $link = $(this);
    var $li = $link.parent('li');
    var $submenu = $li.children('ul');

    if (!$submenu.length) {
        return;
    }

    e.preventDefault();
    e.stopPropagation();

    $('.header__menu--mobile li > ul').not($submenu).slideUp(250);
    $('.header__menu--mobile li').not($li).removeClass('active').addClass('inactive');

    if ($li.hasClass('active')) {
        $submenu.slideUp(250);
        $li.removeClass('active inactive');
    } else {
        $submenu.slideDown(250);
        $li.addClass('active').removeClass('inactive');
    }

});

$(function () {
    var $filter = $('[data-filter]');
    if (!$filter.length) return;

    var $toggle = $filter.find('.collection-filter__toggle');
    var $dropdown = $filter.find('.collection-filter__dropdown');

    $toggle.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var isOpen = !$dropdown.prop('hidden');

        $dropdown.prop('hidden', isOpen);
        $toggle.attr('aria-expanded', String(!isOpen));
    });

    $(document).on('click', function () {
        $dropdown.prop('hidden', true);
        $toggle.attr('aria-expanded', 'false');
    });
});

$(function () {
    var $sort = $('[data-sort]');
    var $toggle = $sort.find('.collection-sort__toggle');
    var $dropdown = $sort.find('.collection-sort__dropdown');

    $toggle.on('click', function (e) {
        e.preventDefault();

        var isOpen = $toggle.attr('aria-expanded') === 'true';

        $toggle.attr('aria-expanded', !isOpen);
        $dropdown.prop('hidden', isOpen);
    });

    $(document).on('click', function (e) {
        if (!$sort.is(e.target) && $sort.has(e.target).length === 0) {
            $toggle.attr('aria-expanded', 'false');
            $dropdown.prop('hidden', true);
        }
    });
});

$(window).on('load', function () {

    var $slider = $('.carousel-1__slider');
    var $progressBar = $('.carousel-1__progress');

    if (!$slider.length || typeof $.fn.slick !== 'function') return;

    var $originalSlides = $slider.children();
    var REAL_COUNT = $originalSlides.length;

    $originalSlides.clone(true).appendTo($slider);
    var TOTAL_COUNT = REAL_COUNT * 2;

    function applyRightPeek() {
        var $list = $slider.find('.slick-list');
        var $slide = $slider.find('.slick-slide').not('.slick-cloned').first();
        if (!$list.length || !$slide.length) return;

        var slideWidth = $slide.outerWidth(true);
        if (!slideWidth) return;

        var peekAmount = slideWidth * 0.2;

        var w = $(window).width();

        if (w <= 600) {
            $list.css({
                paddingRight: peekAmount + 'px',
                paddingLeft: 0,
                width: '100%'
            });

        } else if (w > 600 && w <= 1200) {
            $list.css({
                paddingRight: peekAmount + 'px',
                paddingLeft: 0,
                width: 'calc(200% + ' + peekAmount + 'px)'
            });

        } else if (w > 1200) {
            $list.css({
                paddingRight: peekAmount + 'px',
                paddingLeft: 0,
                width: 'calc(115% + ' + peekAmount + 'px)'
            });
        }
        
    }

    function positionCarouselArrows() {
        var $container = $('.carousel-1 .container');
        var $prev = $slider.find('.slick-prev');
        var $next = $slider.find('.slick-next');

        if (!$container.length || !$prev.length || !$next.length) return;

        var containerOffset = $container.offset().left;
        var containerWidth = $container.outerWidth();
        var viewportWidth = $(window).width();

        $prev.css({
            right: (viewportWidth - (containerOffset + containerWidth - 40)) + 'px'
        });

        $next.css({
            right: (viewportWidth - (containerOffset + containerWidth)) + 'px'
        });
    }

    function setProgressWidth() {
        var $firstSlide = $slider.find('.slick-slide').not('.slick-cloned').first();
        if (!$firstSlide.length) return;

        var slideWidth = $firstSlide.outerWidth(true);

        $progressBar.width((slideWidth) - 30);
    }

    if (!$slider.hasClass('slick-initialized')) {

        $slider.on('init', function () {
            $progressBar.css('background-size', '0% 100%');

            setTimeout(function () {
                $slider.slick('setPosition');
                setProgressWidth();
                applyRightPeek();
                positionCarouselArrows();
            }, 120);
        });

        $slider.on('beforeChange', function (event, slick, current, next) {

            var calc = (next / (TOTAL_COUNT - 1)) * 100;

            var doubledCalc = calc * 2;

            if (doubledCalc > 200) doubledCalc = 200;

            $progressBar
                .css('background-size', doubledCalc + '% 100%')
                .attr('aria-valuenow', Math.round(doubledCalc));
        });

        $slider.on('afterChange', function (e, slick, current) {
            if (current >= REAL_COUNT) {
                slick.slickGoTo(current - REAL_COUNT, false);
            }
        });

        $slider.on('setPosition', function () {
            applyRightPeek();
            positionCarouselArrows();
            setProgressWidth();
        });

        $slider.slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            speed: 400,
            arrows: true,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            prevArrow: `
        <button type="button" class="slick-prev" aria-label="Previous">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="m9.474 5.209s-4.501 4.505-6.254 6.259c-.147.146-.22.338-.22.53s.073.384.22.53c1.752 1.754 6.252 6.257 6.252 6.257.145.145.336.217.527.217.191-.001.383-.074.53-.221.293-.293.294-.766.004-1.057l-4.976-4.976h14.692c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-14.692l4.978-4.979c.289-.289.287-.761-.006-1.054-.147-.147-.339-.221-.53-.221-.191-.001-.38.071-.525.215z"/>
          </svg>
        </button>
      `,
            nextArrow: `
        <button type="button" class="slick-next" aria-label="Next">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="m14.523 18.787s4.501-4.505 6.255-6.26c.146-.146.219-.338.219-.53s-.073-.383-.219-.53c-1.753-1.754-6.255-6.258-6.255-6.258-.144-.145-.334-.217-.524-.217-.193 0-.385.074-.532.221-.293.292-.295.766-.004 1.056l4.978 4.978h-14.692c-.414 0-.75.336-.75.75s.336.75.75.75h14.692l-4.979 4.979c-.289.289-.286.762.006 1.054.148.148.341.222.533.222.19 0 .378-.072.522-.215z"/>
          </svg>
        </button>
      `,
            responsive: [
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                    }
    }]
        });
    }

    $(window).on('resize', function () {
        applyRightPeek();
        positionCarouselArrows();
        setProgressWidth();
    });

});

$(window).on('load', function () {
    var $slider = $('.carousel-2__slider');
    var $progressBar = $('.carousel-2__progress');

    if (!$slider.length || typeof $.fn.slick !== 'function') return;

    if (!$slider.hasClass('slick-initialized')) {

        $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            if (slick.slideCount <= 1) return;

            var calc = (nextSlide / (slick.slideCount - 1)) * 100;

            $progressBar
                .css('background-size', calc + '% 100%')
                .attr('aria-valuenow', calc);
        });

        $slider.slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            speed: 400,
            arrows: true,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            appendArrows: $('.carousel-2__arrows'),

            prevArrow: `
        <button type="button" class="slick-prev carousel-2__arrow" aria-label="Previous">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="m9.474 5.209s-4.501 4.505-6.254 6.259c-.147.146-.22.338-.22.53s.073.384.22.53c1.752 1.754 6.252 6.257 6.252 6.257.145.145.336.217.527.217.191-.001.383-.074.53-.221.293-.293.294-.766.004-1.057l-4.976-4.976h14.692c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-14.692l4.978-4.979c.289-.289.287-.761-.006-1.054-.147-.147-.339-.221-.53-.221-.191-.001-.38.071-.525.215z"/>
          </svg>
        </button>
      `,

            nextArrow: `
        <button type="button" class="slick-next carousel-2__arrow" aria-label="Next">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="m14.523 18.787s4.501-4.505 6.255-6.26c.146-.146.219-.338.219-.53s-.073-.383-.219-.53c-1.753-1.754-6.255-6.258-6.255-6.258-.144-.145-.334-.217-.524-.217-.193 0-.385.074-.532.221-.293.292-.295.766-.004 1.056l4.978 4.978h-14.692c-.414 0-.75.336-.75.75s.336.75.75.75h14.692l-4.979 4.979c-.289.289-.286.762.006 1.054.148.148.341.222.533.222.19 0 .378-.072.522-.215z"/>
          </svg>
        </button>
      `,
            responsive: [
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        centerMode: true,
                    }
    }]
        });
    }
});

$(window).on('load', function () {
    var $slider = $('.news-slider__carousel');

    if (!$slider.length || typeof $.fn.slick !== 'function') return;

    if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '0px',
            arrows: false,
            dots: true,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 400,
            responsive: [
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        centerMode: true,
                    }
    }]
        });
    }
});

$(window).on('load', function () {
    var $slider = $('.carousel-3__slider');

    if (!$slider.length || typeof $.fn.slick !== 'function') return;

    var slideCount = $slider.children().length;

    if ($slider.hasClass('slick-initialized')) return;

    $slider
        .on('init', function () {
            $(this).slick('setPosition');
        })
        .slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: slideCount > 1,
            infinite: slideCount > 1,
            speed: 500,
            adaptiveHeight: true
        });
});


$(window).on('load', function () {

    var $slider = $('.product-images');
    var $progressBar = $('.product-gallery__progress');
    var $progressLabel = $('.product-gallery__progress-label');

    if (!$slider.length || typeof $.fn.slick !== 'function') return;

    if (!$slider.hasClass('slick-initialized')) {

        $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            if (slick.slideCount <= 1) return;

            var calc = (nextSlide / (slick.slideCount - 1)) * 100;

            $progressBar
                .css('background-size', calc + '% 100%')
                .attr('aria-valuenow', calc);

            $progressLabel.text(Math.round(calc) + '% completed');
        });

        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 400,
            arrows: true,
            dots: false,
            infinite: false,
            adaptiveHeight: true,
            prevArrow: `
        <button type="button" class="slick-prev" aria-label="Previous image">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="m9.474 5.209s-4.501 4.505-6.254 6.259c-.147.146-.22.338-.22.53s.073.384.22.53c1.752 1.754 6.252 6.257 6.252 6.257.145.145.336.217.527.217.191-.001.383-.074.53-.221.293-.293.294-.766.004-1.057l-4.976-4.976h14.692c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-14.692l4.978-4.979c.289-.289.287-.761-.006-1.054-.147-.147-.339-.221-.53-.221-.191-.001-.38.071-.525.215z"/>
          </svg>
        </button>
      `,

            nextArrow: `
        <button type="button" class="slick-next" aria-label="Next image">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="m14.523 18.787s4.501-4.505 6.255-6.26c.146-.146.219-.338.219-.53s-.073-.383-.219-.53c-1.753-1.754-6.255-6.258-6.255-6.258-.144-.145-.334-.217-.524-.217-.193 0-.385.074-.532.221-.293.292-.295.766-.004 1.056l4.978 4.978h-14.692c-.414 0-.75.336-.75.75s.336.75.75.75h14.692l-4.979 4.979c-.289.289-.286.762.006 1.054.148.148.341.222.533.222.19 0 .378-.072.522-.215z"/>
          </svg>
        </button>
      `
        });
    }

});

function updateVariantAvailability() {
    var selected = [];

    $('.product-option').each(function () {
        selected.push($(this).find('input:checked').val());
    });

    $('.product__option-input').each(function () {
        var test = selected.slice();
        var index = $(this).closest('.product-option').index();
        test[index] = $(this).val();

        var available = false;

        $('#ProductSelect option').each(function () {
            var text = $(this).data('options');
            if (test.every(v => text.includes(v)) && !this.disabled) {
                available = true;
            }
        });

        $(this)
            .prop('disabled', !available)
            .next('label')
            .toggleClass('product__option--disabled', !available);
    });
}

$(document).on('change', '.product__option-input', updateVariantAvailability);
$(window).on('load', updateVariantAvailability);

$(document).on('click', '[data-accordion-button]', function (e) {
    e.preventDefault();

    var $button = $(this);
    var $section = $button.closest('.accordion__section');
    var $accordion = $button.closest('[data-accordion]');
    var targetId = $button.attr('aria-controls');
    var $content = $('#' + targetId);

    var isOpen = $button.attr('aria-expanded') === 'true';

    $accordion.find('.accordion__section')
        .removeClass('is-active');

    $accordion.find('[data-accordion-button]')
        .attr('aria-expanded', 'false');

    $accordion.find('[data-accordion-content-area]')
        .attr('aria-hidden', 'true')
        .slideUp(250);

    if (!isOpen) {
        $section.addClass('is-active');

        $button.attr('aria-expanded', 'true');

        $content
            .attr('aria-hidden', 'false')
            .slideDown(250);
    }
});

$(function () {

    var isLoading = false;

    function loadMoreOnScroll() {
        var $trigger = $('#InfiniteScrollTrigger');

        if (!$trigger.length || isLoading) return;

        var nextUrl = $trigger.data('next-url');
        if (!nextUrl) return;

        var triggerPoint = $(window).scrollTop() + $(window).height() + 200;
        var gridBottom = $('#BlogGrid').offset().top + $('#BlogGrid').outerHeight();

        if (triggerPoint < gridBottom) return;

        isLoading = true;

        $('#BlogLoading').show();

        $.get(nextUrl, function (response) {

            var $html = $('<div>').html(response);

            var $newItems = $html.find('#BlogGrid .blog-single');
            $('#BlogGrid').append($newItems);

            var $newTrigger = $html.find('#InfiniteScrollTrigger');

            if ($newTrigger.length) {

                $trigger.replaceWith($newTrigger);
                isLoading = false;
            } else {

                $trigger.remove();
                $(window).off('scroll', loadMoreOnScroll);
            }

            $('#BlogLoading').hide();

        }).fail(function () {

            isLoading = false;
            $('#BlogLoading').hide();

        });
    }

    $(window).on('scroll', loadMoreOnScroll);
});

$(document).ready(function () {
    $('.collection-product__image-wrapper').hover(
        function () {
            $(this).find('.image-secondary').css('opacity', 1);
        },
        function () {
            $(this).find('.image-secondary').css('opacity', 0);
        }
    );
});

$(document).on('click', '.qty-btn', function () {
    var $wrapper = $(this).closest('.quantity-selector');
    var $input = $wrapper.find('.qty-input');

    var min = parseInt($input.attr('min')) || 1;
    var value = parseInt($input.val()) || min;

    if ($(this).hasClass('qty-plus')) {
        value++;
    }

    if ($(this).hasClass('qty-minus')) {
        value = Math.max(min, value - 1);
    }

    $input.val(value).trigger('change');
});

$(function () {
    var variants = JSON.parse($('#ProductVariants').html());

    function getSelectedOptions() {
        var options = [];
        $('.product-option').each(function () {
            options.push(
                $(this).find('.product__option-input:checked').val()
            );
        });
        return options;
    }

    function findVariantByOptions(options) {
        return variants.find(function (variant) {
            return variant.options.every(function (opt, index) {
                return opt === options[index];
            });
        });
    }

    function showVariantImage(variant) {
        if (!variant || !variant.featured_image) return;

        var imageId = variant.featured_image.id;
        var $slider = $('.product-images');

        if (!$slider.hasClass('slick-initialized')) return;

        var index = $slider
            .find('.slick-slide')
            .not('.slick-cloned')
            .filter(function () {
                return $(this)
                    .find('.product-image')
                    .data('image-id') == imageId;
            })
            .first()
            .data('slick-index');

        if (typeof index !== 'undefined') {
            $slider.slick('slickGoTo', index, true);
        }
    }

    $('.product__option-input').on('change', function () {
        var options = getSelectedOptions();
        var variant = findVariantByOptions(options);

        if (!variant) return;

        $('#ProductSelect')
            .val(variant.id)
            .trigger('change');

        showVariantImage(variant);
    });

    $('#ProductSelect').on('change', function () {
        var variantId = $(this).val();
        var variant = variants.find(v => v.id == variantId);
        showVariantImage(variant);
    });

    var initialVariant = variants.find(v => v.id == $('#ProductSelect').val());
    showVariantImage(initialVariant);
});

$(document).ready(function () {
    const $container = $('.top-bar');
    const $track = $('.top-bar__track');

    if (!$track.length || !$container.length || $track.hasClass('is-ready')) return;
    $track.addClass('is-ready');

    let isPaused = false;
    let position = 0;
    const speed = 0.5;

    $container.hover(
        () => (isPaused = true),
        () => (isPaused = false)
    );

    function buildLoop() {
        $track.find('[data-clone="true"]').remove();

        const $original = $track.children().not('[data-clone="true"]');
        if ($original.length === 0) return;

        while ($track[0].scrollWidth < $container[0].clientWidth * 2) {
            const $clones = $original.clone(true).attr('data-clone', 'true');
            $track.append($clones);
        }
    }

    function loop() {
        if (!isPaused) {
            position -= speed;

            const half = $track[0].scrollWidth / 2;
            if (Math.abs(position) >= half) position = 0;
        }

        $track.css('transform', `translateX(${position}px)`);
        requestAnimationFrame(loop);
    }

    setTimeout(() => {
        buildLoop();
        loop();
    }, 100);

    $(window).on('resize', () => {
        position = 0;
        setTimeout(buildLoop, 100);
    });
});